import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  VIZ,
  MAX_BAR_THICKNESS,
  axisStyle,
  tooltipStyle,
  valueLabelPlugin,
  formatNumber,
  legendStyle,
} from '../chartTheme';

const bandColor = (index) => VIZ.ordinal[Math.min(index, VIZ.ordinal.length - 1)];

/**
 * Columns for buckets that have a natural order (age bands, weight bands).
 * Ordered categories are the one case where a single-hue ramp is right - it
 * reinforces the order the axis already shows. The ramp is capped at 5 steps,
 * which is as far as the blue ramp keeps visible lightness gaps.
 */
export default function OrdinalColumnChart({ labels, data, seriesLabel = 'Patients', valueFormatter = formatNumber }) {
  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: seriesLabel,
            data,
            backgroundColor: labels.map((_, index) => bandColor(index)),
            maxBarThickness: MAX_BAR_THICKNESS,
            borderRadius: 4,
            borderSkipped: 'start',
          },
        ],
      }}
      plugins={[valueLabelPlugin(valueFormatter)]}
      options={{
        maintainAspectRatio: false,
        layout: { padding: { top: 20 } },
        scales: {
          x: axisStyle(false),
          y: { ...axisStyle(true), beginAtZero: true, ticks: { ...axisStyle().ticks, maxTicksLimit: 5 } },
        },
        plugins: {
          // Each band has its own shade, so the legend lists the bands rather
          // than the single dataset - every colour on the card is named.
          legend: legendStyle({
            labels: {
              generateLabels: (chart) =>
                (chart.data.labels || []).map((label, index) => ({
                  text: String(label),
                  fillStyle: bandColor(index),
                  strokeStyle: bandColor(index),
                  lineWidth: 0,
                  hidden: false,
                  index,
                })),
            },
            onClick: () => {},
          }),
          tooltip: tooltipStyle(valueFormatter),
        },
      }}
    />
  );
}
